import React from 'react'
import { Link } from 'react-router-dom'

export const Button = ({ className, link, text, img, pdf }) => {
    return (
        <>
            {pdf ?
                <a className={className} href={pdf} target='_blank'>
                    <button>
                        <p>
                            {text}
                        </p>
                        <img src={img} />
                    </button>
                </a>
                :
                <Link to={link} className={className}>
                    <button>
                        <p>
                            {text}
                        </p>
                        <img src={img} />
                    </button>

                </Link>}
        </>
    )
}

